//import {connect, useSelector} from "react-redux";
import React, {useCallback, useMemo, useEffect, useState} from "react";
import {
    CAlert,
    CButton,
    CCol,
    CForm,
    CFormInput,
    CFormSelect,
    CInputGroup,
    CInputGroupText,
    CRow,
    CTabPane
} from "@coreui/react";
import connect from "react-redux/es/components/connect";
import {Loading} from "../../../../components/common";
import * as api from "../../../../api/api";
import {AgGridReact} from "ag-grid-react";
import StoreListWhere from "../../where/StoreListWhere";
import {useSelector} from "react-redux";
import StoreCornerListWhere from "../../where/StoreCornerListWhere";
//import StoreDeviceDetail from "./StoreDeviceDetail";


const StoreDevice = (props) => {
    const {user} = useSelector((props) => props.account);


    const containerStyle = useMemo(() => ({width: "100%", height: "100%"}), []);
    const gridStyle = useMemo(() => ({height: 450, width: "100%"}), []);
    const [headerData, setHeaderData] = useState([]);
    const [detailData, setDetailData] = useState([]);

    const [searchForm, setSearchForm] = useState({
        cmpCd: "",
        brandCd: "",
        storeCd: "",
        storeNm: "",
        useYn : "",
        manageDiv: "0"
    });

    //const [selectedStore, setSelectedStore] = useState({});
    const [selectedStoreDevice, setSelectedStoreDevice] = useState({
        deviceCd : "",
        versionCd: "",
        deviceId: "",
        useYn: ""
    });
    const [loading, setLoading] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [error, setError] = useState({visible: false, message: ""});
    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({});

    const onRowSelected = useCallback((event) => {
        //console.log("event.node.data::: ", event.node.data);
        const data = event.node.data;
        setSelectedStoreDevice(event.node.data);
        setVisible(true);
    }, []);

    const defaultColDef = {
        flex: 1,
        resizable: true,
        sortable: true,
        filter: false,
        autoHeaderHeight: true
    };

    const [columnDefs] = useState([
        {field: "storeCd", headerName: "매장코드", width: 100},
        {field: "storeNm", headerName: "매장명", width: 140},
        {field: "deviceNm", headerName: "장비명", width: 90},
        {field: "deviceId", headerName: "POS번호", width: 70},
        {field: "versionNm", headerName: "버전명", width: 70},
        {field: "useYn", headerName: "사용유무", width: 70}
    ]);


    const handleSelect = (code, value) => {
        if (value === "C") {
            setSearchForm((state) => ({
                ...state,
                cmpCd: code
            }));
        } else if (value === "B") {
            setSearchForm((state) => ({
                ...state,
                brandCd: code
            }));
        } else if (value === "S") {
            setSearchForm((state) => ({
                ...state,
                storeCd: code
            }));
        } else if (value === "O") {
            setSearchForm((state) => ({
                ...state,
                cornerCd: code
            }));
        }
    };

    //조회
    const search = async () => {
        setError({visible: false, message: ""});
        const {cmpCd, brandCd, storeCd} = searchForm;
        if (cmpCd.length === 0) {
            setError({
                visible: true,
                message: "운영사 정보를 선택해주세요."
            });
            return;
        }

        const params = {
            cmpCd: cmpCd,
            brandCd: brandCd,
            storeCd: storeCd,
            useYn : formData.useYn
        };
        console.log("params :: " , params);

        setLoading(true);

        try {
            const {data: result} = await api.getStoreDeviceInfo(params);
            const {responseBody, responseCode, responseMessage} = result;
            if (responseCode === "200") {
                // 성공
                console.log("responseBody ::: " , responseBody);
                setRowData(responseBody);
            } else {

            }
        } catch (e) {
            console.error(e.message);
        } finally {
            setLoading(false);
        }
    } //search 종료


    const defaultDeviceInfo = {
        cmpCd: searchForm.cmpCd  ? searchForm.cmpCd : user.cmpCd,
        brandCd: searchForm.brandCd  ? searchForm.brandCd : user.brandCd,
        storeCd: searchForm.storeCd  ? searchForm.storeCd : user.storeCd,
        deviceCd : "POS",
        deviceId : "",
        versionCd : "000000",
        useYn : "Y"
    };

    //신규 등록 시
    const newRegisterPos = () => {

        setSelectedStoreDevice(defaultDeviceInfo);

    } //End newRegisterPos

    //저장
    const save = async () => { //save시작
        const {cmpCd, brandCd, storeCd} = props.selected;

        if(storeCd === ""){
            alert("매장(점포)을 먼저 선택해주세요.");
            return false;
        }

        setError({visible: false, message: ""});
        if (confirm("저장하시겠습니까?")) {
            const storeDevice = {
                ...selectedStoreDevice,
                /*cmpCd: selectedStoreDevice.cmpCd ? selectedStoreDevice.cmpCd : user.cmpCd,
                brandCd: selectedStoreDevice.brandCd ? selectedStoreDevice.brandCd : user.brandCd,
                storeCd: selectedStoreDevice.storeCd ? selectedStoreDevice.storeCd : user.storeCd,*/
                cmpCd: cmpCd,
                brandCd: brandCd,
                storeCd: storeCd,
                deviceCd: selectedStoreDevice.deviceCd ? selectedStoreDevice.deviceCd : defaultDeviceInfo.deviceCd,
                versionCd: selectedStoreDevice.versionCd ? selectedStoreDevice.versionCd :defaultDeviceInfo.versionCd,
                posCd : selectedStoreDevice.posCd ? selectedStoreDevice.posCd :defaultDeviceInfo.deviceId,
                useYn : selectedStoreDevice.useYn ? selectedStoreDevice.useYn :defaultDeviceInfo.useYn,
                instUser: selectedStoreDevice.instUser ? selectedStoreDevice.instUser : user.userId,
                updUser: user.userId,
            }
            setLoading(true);

            try {
                //const {data: result} = await api.putProduct(product);
                const {data: result} = await api.putStoreDevice(storeDevice);
                const {responseBody, responseCode, responseMessage} = result;
                if (responseCode === "200") {
                    // 성공
                    alert("정상적으로 처리되었습니다.");
                    search();
                } else {
                    setError({visible: true, message: responseMessage});
                }
            } catch (e) {
                setError({visible: true, message: e.message});
            } finally {
                setLoading(false);
            }
        }
    } //save 종료



    //-------화면 Grid 영역 시작----------------------------------------------
    return (
        <div style={containerStyle}>
            {loading ? <Loading/> : null}
            {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
            <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
                <h5>점포POS 장비관리</h5>
                <div>
                    <CButton size={"sm"} color="primary" onClick={search}>조회</CButton>
                </div>
            </div>
            <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}  onSelect={(c, v) => handleSelect(c, v)}/>

            <CForm className={"row row-cols-lg-auto p-1"}>
                <CCol xs={12}>
                    <CInputGroup size={"sm"} className={"mb-1"}>
                        <CInputGroupText style={{ width: 80 }}>사용유무</CInputGroupText>
                        <CFormSelect id="useYn"  style={{ width: 130 }}
                                     onChange={(e) => {
                                         setFormData((state) => ({
                                             ...state,
                                             useYn: e.target.value
                                         }));
                                     }}
                        >
                            <option value={""}>전체</option>
                            <option value={"Y"}>사용</option>
                            <option value={"N"}>미사용</option>
                        </CFormSelect>
                    </CInputGroup>
                </CCol>
            </CForm>

            {/*오른쪽 그리드 영역*/}
            <div>
                <CRow>
                    <CCol xs={7}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            점포POS 장비목록
                        </div>
                        <div className="ag-theme-alpine" style={{width: "100%", height: 550, marginTop: 10}}>
                            <AgGridReact
                                rowSelection={"single"}
                                headerHeight={30}
                                rowHeight={30}
                                rowData={headerData}
                                animateRows={true}
                                localeText={{noRowsToShow: "조회 결과가 없습니다."}}
                                rowData={rowData}
                                onRowClicked={onRowSelected}
                                defaultColDef={defaultColDef}
                                columnDefs={columnDefs}>
                            </AgGridReact>
                        </div>
                    </CCol>
                    {/*</CForm>*/}


                    {/*왼쪽 그리드 영역*/}
                    <CCol xs={5}>
                        <div style={{borderRadius: 5, padding: 10, marginBottom: 10, background: "#87CEFA"}}>
                            장비 정보 등록/수정
                        </div>
                        <CRow>
                            <CCol xs={6}>
                                <CInputGroup className={"mb-1"} size={"sm"}>
                                    <CInputGroupText style={{ width: 80 }}>장비구분</CInputGroupText>
                                    <CFormSelect id="deviceCd" name="deviceCd" value={selectedStoreDevice.deviceCd} disabled={true}
                                                 onChange={(e) => {
                                                     setSelectedStoreDevice((state) => ({
                                                         ...state,
                                                         deviceCd: e.target.value
                                                     }))
                                                 }}
                                    >
                                        <option value={"POS"}>POS</option>
                                        {/*<option value={"KIOSK"}>KIOSK</option>*/}
                                    </CFormSelect>
                                </CInputGroup>
                            </CCol>
                            <CCol xs={6}>
                                <CInputGroup className={"mb-1"} size={"sm"}>
                                    <CInputGroupText style={{ width: 80 }}>버전정보</CInputGroupText>
                                    <CFormSelect id="versionCd" name="versionCd" value={selectedStoreDevice.versionCd}
                                                 onChange={(e) => {
                                                     setSelectedStoreDevice((state) => ({
                                                         ...state,
                                                         versionCd: e.target.value
                                                     }))
                                                 }}

                                    >
                                        <option value={"000000"}>O2POS</option>
                                        <option value={"000002"}>키오스크</option>
                                    </CFormSelect>
                                </CInputGroup>
                            </CCol>

                            <CCol xs={6}>
                                <CInputGroup className={"mb-1"} size={"sm"}>
                                    <CInputGroupText style={{ width: 80 }}>POS번호</CInputGroupText>
                                    <CFormInput id="deviceId" name="deviceId" value={selectedStoreDevice.deviceId}
                                                onChange={(e) => {
                                                    setSelectedStoreDevice((state) => ({
                                                        ...state,
                                                        deviceId: e.target.value
                                                    }))
                                                }}
                                    />
                                </CInputGroup>
                            </CCol>


                            <CCol xs={6}>
                                <CInputGroup className={"mb-1"} size={"sm"}>
                                    <CInputGroupText style={{ width: 80 }} >사용유무</CInputGroupText>
                                    <CFormSelect id="useYn" name="useYn" value={selectedStoreDevice.useYn}
                                                onChange={(e) => {
                                                    setSelectedStoreDevice((state) => ({
                                                        ...state,
                                                        useYn: e.target.value
                                                    }))
                                                }}
                                    >
                                    <option value={"Y"}>사용</option>
                                    <option value={"N"}>미사용</option>
                                    </CFormSelect>
                                </CInputGroup>
                            </CCol>

                        </CRow>
                        <div className="d-grid gap-1" style={{marginTop: 10}}>
                            <CButton color="dark" onClick={newRegisterPos} >신규</CButton>
                            <CButton onClick={save}>저장</CButton>
                        </div>
                    </CCol>


                    {/*  오른쪽 상세 영역(디테일)*/}
                    {/*<CCol xs={5}>*/}
                    {/*<div style={{height: 10}}/>*/}
                    {/*<StoreDeviceDetail />    info={selectedStore}*/}
                    {/*</CCol>*/}
                </CRow>


            </div>
        </div>


    );


};

const mapStateToProps = (state) => {
    const {account, store, selected} = state;
    return {
        account, store, selected
    };
};
export default connect(mapStateToProps, null)(StoreDevice);
